export const LOCAL_STORAGE_AUTH_KEY = 'CLIENT_LOCAL_STORAGE_AUTH_KEY';
export const LOCAL_STORAGE_MATER_AUTH_KEY = 'CLIENT_LOCAL_STORAGE_MASTER_AUTH_KEY';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_WITH_TIME = 'DD/MM/YYYY, h:mm:ss A';
export const TABLE_DEFAULT_LIMIT = 20;

export const SECTIONS = [
  {
    value: 'Cake',
    label: 'Cake',
  },
];

export const TYPE = [
  {
    value: 'FREE',
    label: 'Free',
  },
  {
    value: 'PAID',
    label: 'Paid',
  },
];

export const SERVICE_STATUS_TYPE = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  OVERDUE: 'OVERDUE',
};

export const SERVICESTATUS = [
  {
    value: SERVICE_STATUS_TYPE.PENDING,
    label: 'Pending',
  },
  {
    value: SERVICE_STATUS_TYPE.COMPLETED,
    label: 'Completed',
  },
];

export const BREAKDOWNSTATUS = [
  {
    value: 'PENDING',
    label: 'Pending',
  },
  {
    value: 'REPAIRED',
    label: 'Repaired',
  },
];

export const RESELL_SCRAP_TYPE = {
  SCRAP: 'SCRAP',
  RESELL: 'Resell',
};

export const REPORT_FOR = {
  MACHINE: 'MACHINE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  INSTALLATION: 'INSTALLATION',
  SERVICE: 'SERVICE',
  BREAKDOWN: 'BREAKDOWN',
  RESELL: 'RESELL',
};

export const CURRENCY_CODE = {
  INR: 'INR',
  IDR: 'IDR',
  ILS: 'ILS',
  MXN: 'MXN',
  USD: 'USD',
  ZAR: 'ZAR',
  NZD: 'NZD',
  NOK: 'NOK',
  CNY: 'CNY',
  BGN: 'BGN',
  TRY: 'TRY',
  PLN: 'PLN',
  SGD: 'SGD',
  CHF: 'CHF',
  THB: 'THB',
  JPY: 'JPY',
  HRK: 'HRK',
  RUB: 'RUB',
  BRL: 'BRL',
  CAD: 'CAD',
  HKD: 'HKD',
  ISK: 'ISK',
  PHP: 'PHP',
  DKK: 'DKK',
  HUF: 'HUF',
  CZK: 'CZK',
  RON: 'RON',
  SEK: 'SEK',
  AUD: 'AUD',
  EUR: 'EUR',
  MYR: 'MYR',
  KRW: 'KRW',
  GBP: 'GBP',
};

export const ROLE = {
  ADMIN: 'admin',
  EMPLOYEE: 'employee',
};

export const MACHINE_STATUS = {
  INITIATED: 'INITIATED',
  APPROVED: 'APPROVED',
  INSTALLED: 'INSTALLED',
};

export const states = [
  { label: 'Andaman and Nicobar Islands', value: 'AN' },
  { label: 'Andhra Pradesh', value: 'AP' },
  { label: 'Arunachal Pradesh', value: 'AR' },
  { label: 'Assam', value: 'AS' },
  { label: 'Bihar', value: 'BR' },
  { label: 'Chandigarh', value: 'CH' },
  { label: 'Chhattisgarh', value: 'CG' },
  { label: 'Dadra and Nagar Haveli and Daman and Diu', value: 'DD' },
  { label: 'Delhi', value: 'DL' },
  { label: 'Goa', value: 'GA' },
  { label: 'Gujarat', value: 'GJ' },
  { label: 'Haryana', value: 'HR' },
  { label: 'Himachal Pradesh', value: 'HP' },
  { label: 'Jammu and Kashmir', value: 'JK' },
  { label: 'Jharkhand', value: 'JH' },
  { label: 'Karnataka', value: 'KA' },
  { label: 'Kerala', value: 'KL' },
  { label: 'Ladakh', value: 'LA' },
  { label: 'Lakshadweep', value: 'LD' },
  { label: 'Madhya Pradesh', value: 'MP' },
  { label: 'Maharashtra', value: 'MH' },
  { label: 'Manipur', value: 'MN' },
  { label: 'Meghalaya', value: 'ML' },
  { label: 'Mizoram', value: 'MZ' },
  { label: 'Nagaland', value: 'NL' },
  { label: 'Odisha', value: 'OR' },
  { label: 'Pondicherry', value: 'PY' },
  { label: 'Punjab', value: 'PB' },
  { label: 'Rajasthan', value: 'RJ' },
  { label: 'Sikkim', value: 'SK' },
  { label: 'Tamil Nadu', value: 'TN' },
  { label: 'Telangana', value: 'TG' },
  { label: 'Tripura', value: 'TR' },
  { label: 'Uttar Pradesh', value: 'UP' },
  { label: 'Uttarakhand', value: 'UT' },
  { label: 'West Bengal', value: 'WB' },
];

export const DEBOUNCE_DELAY = 500;

//Items
export const units = [
  { label: 'Kg', value: 'Kg' },
  { label: 'Gram', value: 'Gram' },
  { label: 'Pkt', value: 'Pkt' },
  { label: 'Bottle', value: 'Bottle' },
  { label: 'Nos', value: 'Nos' },
  { label: 'Tin', value: 'Tin' },
  { label: 'Bag', value: 'Bag' },
  { label: 'Pcs', value: 'Pcs' },
  { label: 'Meters', value: 'Meters' },
  { label: 'Lttr', value: 'Lttr' },
  { label: 'Cont', value: 'Cont' },
  { label: 'Rolls', value: 'Rolls' },
  { label: 'Book', value: 'Book' },
  { label: 'Rims', value: 'Rims' },
  { label: 'Box', value: 'Box' },
  { label: 'Lumpsum[LS]', value: 'Lumpsum[LS]' },
  { label: 'Dozen', value: 'Dozen' },
];

export const item_classes = [
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'Godown', value: 'Godown' },
];
export const indentOrderType = [
  { label: 'Mandi', value: 'Mandi' },
  { label: 'Non-Mandi', value: 'Non-Mandi' },
  { label: 'Packing', value: 'Packing' },
];

export const monthsDropdown = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const COMPANY_ID = 1;
